// extracted by mini-css-extract-plugin
export default {"commentList":"comments-list_commentList__nPTUy"};